export default __webpack_public_path__ + "4b1ea3a18ea66077fb8862b6c7375330.svg";